(function () {
  'use strict';

  angular
    .module('aircraftRegistration')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('aircraftRegistration', {
        url: '/aircraft-registration',
        views: {
            'acRegView': {
            	templateUrl: 'aircraft-registration/views/aircraft-registration.tpl.html',
                controller: 'AircraftRegistrationCtrl',
                controllerAs: 'aircraftRegistration'
            }
        },
        
      });
  }
}());


